import React, { useEffect } from "react";
import {
  Alert,
  Row,
  Col,
  Button,
  Spin,
  Dropdown,
  Menu,
  Empty,
  Skeleton,
  Badge,
  List,
  Avatar,
  Card,
} from "antd";
import {
  BellOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import FaceLivenessScanner from "../Settings/Personal Settings/FaceLivenessScanner";
import PolicyCard from "../Policies/PolicyCard";
import DashboardCarousel from "./DashboardCarousel";

import PendingLoansCarousel from "./PendingLoansCarousel";
import RecommendedForYou from "./RecommendedForYou";
import products from "../../utils/data/products";
import DepositCard from "../Policies/DepositCard";
import useWindowSize from "../../utils/helper/useWindowSize";
import { useDashboard } from "../../store/context/DashboardContext";
import { useTranslation } from "react-i18next";
import { useFeatures } from "../../store/context/feature-context";
import { useState } from "react";
import { featuresEnum } from "../../shared/constants/constants";

import { getSessionData } from "../../utils/interceptors/localStorageService";
import { useNotification } from "../../store/context/notification-context";
import { usePermissions } from "../../store/context/permission-context";
import DashboardCards from "./DashboardCards";
import QuickActionsCard from "./DashardQuickActionsCard";
import AccountSummaryCard, {
  exampleAccount,
} from "./DashboardAccountSummaryCard";
import DidYouKnowCard from "./DashboardDidYouKnow";
import {
  loadNotificationsFromSession,
  clearNotificationsFromSession,
} from "../../utils/helper/util";

import { formatRelativeTime } from "../../utils/helper/format";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isFaceLivenessOpen, setIsFaceLivenessOpen] = useState(false);
  const [showFaceLivenessAlert, setShowFaceLivenessAlert] = useState(false);

  const {
    selectedFilter,
    setSelectedFilter,
    savedSessionData,
    policies,
    getUserData,
    fetchPolicies,
    pendingQuotes,
    loading,
    error,
    depositPolicies,
    bankingProfile,
  } = useDashboard();
  // Profile-only customers (anonymous loan applicants, no core banking account).
  const requiresAccount = bankingProfile?.hasCoreBankingAccounts === false;
  console.log("savedSessionData", savedSessionData);
  const { triggerNotification } = useNotification();
  const { permissions } = usePermissions();

  const { t } = useTranslation();

  const { findFeature } = useFeatures();
  const [notificationList, setNotificationList] = useState([]);
  const [categories, setCategories] = useState([]);

  console.log("permissions from context-dashboard", permissions);

  const handleFilterChange = (filter) => setSelectedFilter(filter);

  const handlePolicyClick = (policyNumber) => {
    // navigate(`/policies/${policyNumber}`);
  };

  // console.log("product ", products);
  const favProducts = products
    .filter((product) => product.category === "loans")
    .slice(0, 3);

  useEffect(() => {
    setNotificationList(loadNotificationsFromSession(savedSessionData?.userId));
  }, [savedSessionData?.userId]);

  // Profile-only customers can only view loans; default the filter to it.
  useEffect(() => {
    if (requiresAccount) {
      setSelectedFilter("loans");
    }
  }, [requiresAccount, setSelectedFilter]);

  useEffect(() => {
    let allCategories = [
      { key: "deposits", label: "Deposits" },
      { key: "loans", label: "Loans" },
      { key: "investments", label: "Investments" },
      { key: "insurance", label: "Insurance" },
    ];
    const categoriesFilterd = allCategories.filter((category) => {
      if (category.key === "loans") {
        return findFeature(featuresEnum.CUSTOMER_LOAN);
      }
      if (category.key === "insurance") {
        return findFeature(featuresEnum.CUSTOMER_INSURANCE);
      }
      return true; // Keep other categories by default
    });
    setCategories(categoriesFilterd);

    console.log(categoriesFilterd);
    // Use `filteredCategories` as needed
  }, [findFeature]);

  useEffect(() => {
    const sessionData = getSessionData();
    console.log("sessiondata from dashboard is ", sessionData);

    if (!sessionData) {
      navigate("/authentication?mode=signin");
    } else if (!sessionData?.mobileNumber) {
      getUserData();
    }
  }, [triggerNotification, navigate, getUserData]);

  useEffect(() => {
    // Only show once we have a definitive backend/session boolean.
    // This prevents a brief flash while session state is still hydrating.
    const hasCompleted = savedSessionData?.hasCompletedLivenessCheck;
    setShowFaceLivenessAlert(hasCompleted === false);
    console.log("savedSessionData from useEffect", savedSessionData);
  }, [savedSessionData?.hasCompletedLivenessCheck]);

  const handleViewProducts = () => {
    navigate("/products", { state: { default: "all" } });
  };

  const handlePinSetUp = () => {
    navigate("/settings/security/setup-pin");
  };
  const handleNotificationClick = (id) => {
    navigate(`/messages/${id}`); // Navigate to the full message page
  };

  // if (loading) {
  //   return (

  //     <Skeleton
  //       active
  //       paragraph={{
  //         rows: 5,
  //       }}
  //       className="mt-10"
  //     />
  //   );
  // }

  if (error) {
    console.error(error);
    return <div>An error occurred. Please try again.</div>;
  }

  // if (!policies || policies.length === 0) {
  //   return <Empty description="No policies found" />;
  // }

  const sortedPolicies = policies
    .slice()
    .sort((a, b) => a.type.localeCompare(b.type));
  const filteredPolicies = sortedPolicies.filter((policy) =>
    policy.type.includes(selectedFilter),
  );

  const isPinSet = savedSessionData?.isPinSet;

  // For profile-only customers, surface Loans first and keep it selected.
  const displayCategories = requiresAccount
    ? [...categories].sort((a, b) =>
        a.key === "loans" ? -1 : b.key === "loans" ? 1 : 0,
      )
    : categories;

  const notificationMenu = (
    <Card
      // style={{
      //   width: "340px",
      //   maxHeight: "400px",
      //   overflowY: "auto",
      // }}
      className="overflow-y-auto w-72 max-h-96 md:w-80"
      bodyStyle={{ padding: 0 }}
    >
      <List
        size="small"
        header={
          <div className="flex justify-between items-center px-4">
            <span>Notifications</span>
            {!!notificationList.length && (
              <Button
                type="text"
                size="small"
                onClick={() => {
                  clearNotificationsFromSession(savedSessionData?.userId);
                  setNotificationList([]);
                }}
              >
                Clear All
              </Button>
            )}
          </div>
        }
        // itemLayout="horizontal"
        dataSource={notificationList}
        locale={{ emptyText: "No notifications" }}
        renderItem={(item) => (
          <List.Item
          // onClick={() => handleNotificationClick(item.id)}
          // style={{ cursor: "pointer" }}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  icon={
                    <BellOutlined size={"small"} style={{ fontSize: "14px" }} />
                  }
                />
              }
              title={<span className="text-xs">{item.message}</span>}
              description={
                <div className="text-xs text-right">
                  {formatRelativeTime(item.timestamp)}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
  return (
    <div className="p-4 pt-5 mb-10">
      {showFaceLivenessAlert && (
        <Alert
          className="mb-4"
          type="warning"
          showIcon
          message={t("Liveness check required")}
          description={t(
            "Liveness verification is required to continue transacting on this platform. Please complete it within the next few days to avoid transaction restrictions. If your current device has no camera, you can complete it on a mobile phone.",
          )}
          action={
            <Button
              type="primary"
              onClick={() => {
                setIsFaceLivenessOpen(true);
              }}
            >
              {t("Start Verification")}
            </Button>
          }
        />
      )}
      <FaceLivenessScanner
        open={isFaceLivenessOpen}
        onClose={() => {
          setIsFaceLivenessOpen(false);
        }}
        onCompleted={() => {
          setShowFaceLivenessAlert(false);
          setIsFaceLivenessOpen(false);
        }}
      />
      {/* Header */}
      <div className="mb-5 pt-[6px] flex justify-between items-center">
        <p className="h-[28px] text-[18px] text-[#615D5D]f">
          Good Morning,{" "}
          <b className="font-boldf capitalize text-[#221F1F]f">
            {savedSessionData?.firstName}
          </b>
        </p>
        {/* {findPermission(PermissionsEnum.ADM_NOTIFICATIONS) && (
      )} */}
        <Dropdown overlay={notificationMenu} trigger={["click"]}>
          <Badge count={notificationList.length} offset={[5, 0]}>
            <BellOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
          </Badge>
        </Dropdown>
      </div>

      <Row gutter={[24, 20]}>
        <Col xs={24} xxl={15}>
          <div className="mb-8">
            <Row gutter={16} className="mb-8">
              {isPinSet && (
                <Col>
                  <div
                    className="shadow-md hover:shadow-lg border border-gray-300 rounded-lg max-w-80 h-[266px] cursor-pointer mb-4"
                    onClick={handleViewProducts}
                  >
                    <div className="flex flex-col justify-center items-center w-full transition-shadow duration-300">
                      <img
                        src={"/dashboard.svg"}
                        className="object-contain mb-6"
                        alt="Insurance Modal"
                      />
                      <div className="px-3 w-full">
                        <h4 className="text-[14px] font-semibold">
                          {t("Need a new account?")}
                        </h4>
                        <p className="text-[12px] mb-2 pt-2">
                          {t(
                            "Open an account with us to save, invest, borrow, or protect your future",
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              <Col>
                {isPinSet ? (
                  <QuickActionsCard />
                ) : (
                  <div
                    className="shadow-md hover:shadow-lg border border-gray-300 rounded-lg max-w-80 h-[266px] cursor-pointer mb-4 ml-4"
                    onClick={handlePinSetUp}
                  >
                    <div className="flex flex-col justify-center items-center w-full transition-shadow duration-300">
                      <img
                        src={"/pin.svg"}
                        className="object-contain mb-6"
                        alt="Setup PIN"
                      />
                      <div className="px-3 w-full">
                        <h4 className="text-[14px] font-semibold">
                          Setup Transaction PIN{" "}
                          <ExclamationCircleOutlined className="text-lg text-red-600" />
                        </h4>
                        <p className="text-[12px] mb-2 pt-2">
                          Without your transaction pin, you would not be able to
                          carry out any transactions.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            </Row>

            {!!depositPolicies.length && <AccountSummaryCard />}

            {/* <Row gutter={24} className="mt-4 w-full">
              =
              <Col span={24}>
                <DidYouKnowCard />
              </Col>
            </Row> */}
          </div>

          {!!pendingQuotes?.length && <PendingLoansCarousel />}

          <div className="my-10">
            <div className="flex gap-2 items-center mb-2">
              <p className="text-lg font-semibold">{t("My Accounts")}</p>
              <Button
                icon={<ReloadOutlined />}
                size="small"
                onClick={fetchPolicies}
                className="flex items-center p-1 text-gray-600 bg-transparent border-none shadow-none hover:bg-gray-200"
              ></Button>
            </div>

            <div>
              <div className="mb-7">
                <Row gutter={16} className="block md:hidden">
                  <Col span={24}>
                    <Dropdown
                      overlay={
                        <Menu>
                          {(displayCategories ?? []).map((category) => (
                            <Menu.Item
                              key={category.key}
                              disabled={
                                requiresAccount && category.key !== "loans"
                              }
                              onClick={() => handleFilterChange(category.key)}
                            >
                              {category.label}
                            </Menu.Item>
                          ))}
                        </Menu>
                      }
                      trigger={["click"]}
                      className="w-full"
                    >
                      <Button type="default" className="w-full">
                        {categories.find((cat) => cat.key === selectedFilter)
                          ?.label || "Select Category"}
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
                <Row gutter={16} className="hidden items-center md:flex">
                  {displayCategories.map((category) => (
                    <Col key={category.key}>
                      <Button
                        disabled={requiresAccount && category.key !== "loans"}
                        className={
                          selectedFilter === category.key
                            ? "text-[#e5791b] border-[#e5791b] font-semibold border-2 rounded"
                            : "border-2 font-semibold rounded border-gray-300"
                        }
                        onClick={() => handleFilterChange(category.key)}
                      >
                        {category.label}
                      </Button>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>

            {loading ? (
              <Skeleton
                active
                paragraph={{
                  rows: 5,
                }}
                className="mt-10"
              />
            ) : (
              <div className="relative ml-[-6px]">
                {filteredPolicies.length > 0 ? (
                  <DashboardCarousel
                    slides={filteredPolicies.map((policy) =>
                      policy.type === "deposits" || policy.type === "loans" ? (
                        <DepositCard
                          key={policy.policyNumber}
                          policy={policy}
                          onClick={() => handlePolicyClick(policy.policyNumber)}
                        />
                      ) : (
                        <PolicyCard
                          key={policy.policyNumber}
                          policy={policy}
                          onClick={() => handlePolicyClick(policy.policyNumber)}
                        />
                      ),
                    )}
                  />
                ) : (
                  <Empty description={`No ${selectedFilter} available`} />

                  // <Empty
                  //   image="/no-data.svg"
                  //   description="No accounts yet? Get started with our banking services."
                  // >
                  //   <Button type="primary" onClick={handleViewProducts}>
                  //     Open an Account
                  //   </Button>
                  // </Empty>
                )}
              </div>
            )}
          </div>

          {findFeature(featuresEnum.CUSTOMER_LOAN) &&
            favProducts.length > 0 && (
              <div className="mb-10">
                <div className="mb-2">
                  <p className="mb-5 text-lg font-semibold text-left">
                    {t("Recommended for you")}
                  </p>
                  <div className="text-[14px] font-sm">
                    {t("We thought this might interest you")}
                  </div>
                </div>
                <RecommendedForYou favProducts={favProducts} />
              </div>
            )}
        </Col>

        <Col xs={24} xxl={9}>
          <DashboardCards />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
